import type { CSSProperties } from 'react';
import type { TransitionStatus } from 'react-transition-group';

type TransitionStyles = Record<TransitionStatus, CSSProperties>;

/**
 * Provides a way to reference the styles for animation states of a TransitionGroup.
 */
export const transitionStyles =
  (styles: Partial<TransitionStyles> = {}) =>
  (status: TransitionStatus) => {
    return {
      entered: {},
      entering: {},
      exited: {},
      exiting: {},
      unmounted: {},
      ...styles,
    }[status];
  };
